export function getLoginUserDetails(): Record<string, unknown> | null {
  try {
    const raw = localStorage.getItem('loginUserDetails');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

/** employee_id from loginUserDetails (same source as onboarding API params). */
export function getLoginEmployeeId(user?: Record<string, unknown> | null): string | number | null {
  const loginUser = user ?? getLoginUserDetails();
  const employeeId = loginUser?.['employee_id'];
  if (employeeId == null || String(employeeId).trim() === '') {
    return null;
  }
  return employeeId as string | number;
}

/** entity_id from loginUserDetails (same source as employee_id). */
export function getLoginEntityId(user?: Record<string, unknown> | null): string | number | null {
  const loginUser = user ?? getLoginUserDetails();
  if (!loginUser) {
    return null;
  }

  const entityId = loginUser['primary_entity_id'] ?? loginUser['entity_id'];
  if (entityId == null || String(entityId).trim() === '') {
    return null;
  }
  return entityId as string | number;
}

/** Supports isOnboardingComplete / IsonboardingComplete from SignIn API. */
export function isOnboardingCompleteFromUser(user: Record<string, unknown> | null): boolean {
  if (!user) {
    return false;
  }
  const value =
    user['isOnboardingComplete'] ??
    user['IsonboardingComplete'] ??
    user['is_onboarding_complete'];
  return value === true || value === 'true';
}

export function isOnboardingComplete(): boolean {
  return isOnboardingCompleteFromUser(getLoginUserDetails());
}

export function setOnboardingCompleteInStorage(complete: boolean): void {
  const user = getLoginUserDetails();
  if (!user) {
    return;
  }
  user['isOnboardingComplete'] = complete;
  user['IsonboardingComplete'] = complete;
  localStorage.setItem('loginUserDetails', JSON.stringify(user));
}

export function getEmployeeDisplayName(): string {
  try {
    const stored = localStorage.getItem('full_name');
    if (stored) {
      return JSON.parse(stored);
    }
  } catch {
    /* fall through */
  }
  const user = getLoginUserDetails();
  const first = (user?.['first_name'] as string) || '';
  const last = (user?.['last_name'] as string) || '';
  return `${first} ${last}`.trim() || 'Employee';
}

export function getInitialsFromName(name: string): string {
  const parts = name.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase() || 'EM';
}

export function getEmployeeInitials(): string {
  return getInitialsFromName(getEmployeeDisplayName());
}
